import React, { useContext, useMemo } from 'react';
import { Table } from 'reactstrap';
import { CustomerServiceDashboardContext } from '../../context';
import { EventType, MonitoringLog } from '../../../../Controllers/CustomerServiceDashboard/CustomerServiceDashboard';
import styles from './AccountMonitorList.module.scss';
import classNames from 'classnames/bind';
import {useCustomerServiceDashboardStore} from "../../store";

const classes = classNames.bind(styles);

interface MonitoringLogUser extends Mri.Web.Internal.Controllers.Account.UserModel {
    stats: {
        displaysMonitored: number;
        incidentsFound: number;
        ticketsRaised: number;
        incidentsFixed: number;
        other: number;
    };
}
const AccountMonitorList = () => {
    const {monitoringLogsByUser} = useCustomerServiceDashboardStore();
    const monitoringLogStats = useMemo(() => {
        if (!monitoringLogsByUser) return [];
        return Object.keys(monitoringLogsByUser).map(
            (userName: Mri.Web.Internal.Controllers.Account.UserModel['userName']) => {
                const logs = monitoringLogsByUser[userName];
                const stats = {
                    displaysMonitored: 0,
                    incidentsFound: 0,
                    ticketsRaised: 0,
                    incidentsFixed: 0,
                    other: 0,
                };
                logs.forEach((log: MonitoringLog) => {
                    if (log.incidentType === EventType.Incident) {
                        stats.incidentsFound++;
                    }
                    if (log.incidentType === EventType.Ticket) {
                        stats.ticketsRaised++;
                    }
                    if (log.incidentType === EventType.Monitoring) {
                        stats.displaysMonitored++;
                    }
                    if (log.resolved) {
                        stats.incidentsFixed++;
                    }
                });
                return { userName, stats } as MonitoringLogUser;
            }
        );
    }, [monitoringLogsByUser]);
    const totalStats = useMemo(() => {
        const stats = { displaysMonitored: 0, incidentsFound: 0, ticketsRaised: 0, incidentsFixed: 0, other: 0 };
        if (!monitoringLogStats) return stats;
        monitoringLogStats.forEach((user: MonitoringLogUser) => {
            stats.displaysMonitored += user.stats.displaysMonitored;
            stats.incidentsFound += user.stats.incidentsFound;
            stats.ticketsRaised += user.stats.ticketsRaised;
            stats.incidentsFixed += user.stats.incidentsFixed;
            stats.other += user.stats.other;
        });
        return stats;
    }, [monitoringLogStats]);
    return (
        <>
            <h3>Account Monitor List</h3>
            <Table className={classes('monitor-list')}>
                <thead>
                    <tr>
                        <th>Monitorer</th>
                        <th>Displays Monitored</th>
                        <th>Incidents Found</th>
                        <th>Tickets Raised</th>
                        <th>Incidents Fixed</th>
                        <th>Other</th>
                    </tr>
                </thead>
                <tbody>
                    {monitoringLogStats &&
                        monitoringLogStats.map((user: MonitoringLogUser, index: number) => (
                            <tr key={index}>
                                <td>{user.userName}</td>
                                <td>{user.stats.displaysMonitored}</td>
                                <td>{user.stats.incidentsFound}</td>
                                <td>{user.stats.ticketsRaised}</td>
                                <td>{user.stats.incidentsFixed}</td>
                                <td>{user.stats.other}</td>
                            </tr>
                        ))}
                    <tr className={classes('total-row')}>
                        <td>Totals</td>
                        <td>{totalStats.displaysMonitored}</td>
                        <td>{totalStats.incidentsFound}</td>
                        <td>{totalStats.ticketsRaised}</td>
                        <td>{totalStats.incidentsFixed}</td>
                        <td>{totalStats.other}</td>
                    </tr>
                </tbody>
            </Table>
        </>
    );
};

export default AccountMonitorList;
